// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".automatic-flex-box{\n    display:flex;\n    flex-wrap: wrap;\n    grid-gap: 1rem;\n    gap: 1rem;\n    padding-top: .25rem\n}", "",{"version":3,"sources":["webpack://src/components/Boletos/styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,cAAS;IAAT,SAAS;IACT;AACJ","sourcesContent":[".automatic-flex-box{\n    display:flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    padding-top: .25rem\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
